import React, { useState } from 'react';

import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import {Navigate, useNavigate} from 'react-router-dom';

import {
  getAccessInfo,
  getUserInfo,
  hasPermission,
} from '../../authentication/authenticationHelper';
import Manual from '../../documents/Manual de Credenciacao das EA.pdf';
import Portaria from '../../documents/Portaria.pdf';
import Regulamento from '../../documents/Regulamento Empreende XXI.pdf';
import ConceitoProjetoInovador from '../../documents/EMPREENDEEXXI_CONCEITO-DE-PROJETO-INOVADOR.pdf';
import RegraMinimis from '../../documents/Minuta Declaração de Empresa .docx';
import EADistrict from '../../documents/eas_distrito.pdf';
import EAOrder from '../../documents/eas_alfabetica.pdf';
import Faqs from '../../documents/FAQs.pdf'
import { UserState } from '../../models/UserState';
import {ConfigObject} from "../../config";

function Home() {
  const [promoShow, setPromoShow] = useState(false);
  const [entShow, setEntShow] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [currentVideo, setCurrentVideo] =useState('../../videos/pedido-de-mentoria.mp4')

  const accessInfo = getAccessInfo();
  const userInfo = getUserInfo();

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  async function openDocumentation() {
    window.location.href = "#documentacao"
    await sleep(100);
    await setPromoShow(false);

  }

 function handleVideoToggle(videoNum) {
 const video1 = require('../../videos/pedido-de-mentoria.mp4');
 const video2 = require('../../videos/acompanhamento-e-avaliacao.mp4');
 const video3 = require('../../videos/relatorio-semestral-e-final.mp4');
 const video4 = require('../../videos/plano-anual-de-atividades.mp4');
 const video5 = require('../../videos/acompanhamento-das-candidaturas.mp4');
 const video6 = require('../../videos/incumprimentos-irregularidades.mp4');
 let videoSrc='';


   const container = document.getElementById('video-container');
   if (!container) return;

   container.innerHTML = ''; // limpar
   const video = document.createElement('video');

   switch(videoNum){
    case 1:
        videoSrc=video1;
        break;
    case 2:
        videoSrc=video2;
        break;
    case 3:
        videoSrc=video3;
        break;
    case 4:
        videoSrc=video4;
                break;
    case 5:
        videoSrc=video5;
        break;
    case 6:
        videoSrc=video6;
        break;
   }

   video.src = videoSrc;
   //video.width = 636;
   //video.height = 358;
   video.autoplay = true;
   video.controls = true;

   container.appendChild(video);
 };



  const firstTimeHome = sessionStorage.getItem('firstTimeHome') || 'yes';

  if (
    userInfo !== null &&
    userInfo.userState === UserState.VALIDATE &&
    hasPermission('COMPLETE_INFORMATION', accessInfo)
  ) {
    return <Navigate to='/completarRegisto' />;
  }

  if (
    userInfo !== null && userInfo.userType==='PROMOTER' &&
    userInfo.userState === UserState.CREATED &&
    firstTimeHome === 'yes'
  ) {
    sessionStorage.setItem('firstTimeHome', 'no');
    return <Navigate replace to='/candidatura' />;
  }

  return (
    <div>
      <header className='masthead'>
        <Container>
          <Row>
            <Col md='12'>
              <h1 className='masthead-subheading mx-1'>
                <FormattedMessage id='home.text1' />
              </h1>
              <h2 className='masthead-heading'>
                <FormattedMessage id='home.text2' />
              </h2>
            </Col>
          </Row>
        </Container>
        <div className='banner'></div>
      </header>

      <section className="bg-warning">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-8 offset-lg-3 offset-md-2 py-4">
              <h3 className="mt-0 mb-3"><FormattedMessage id='home.text40' /></h3>
              <strong><FormattedMessage id='home.text41' /></strong>
              <p>
                <FormattedMessage id='home.text42' />
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id='o-que-e' className='bg-white'>
        <Container>
          <Row>
            <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
              <h3 className='mt-0 mb-3'>
                <FormattedMessage id='home.text3' />
              </h3>
              <p>

                <strong className='text-primary'>
                  <FormattedMessage id='home.text4' />
                </strong>

              </p>
              <p>
                <FormattedMessage id='home.text5' />
              </p>
              <p>
                <FormattedMessage id='home.text6' />
              </p>
              <p>
                <FormattedMessage id='home.text7' />
              </p>
              <p>
                <FormattedMessage id='home.text8' />
              </p>
            </Col>
          </Row>
        </Container>
      </section>
        <hr class="m-0"/>
        <section id="videos" class="bg-white">
          <div class="container pt-3">
            <h3 className="mb-4 px-1"><FormattedMessage id={'homeVideos.title'}/></h3>
            <div class="row flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <div class="ps-3 video-links">
                    <ul>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(1)}><FormattedMessage id={'homeVideo.video1'} /></p></li>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(2)}><FormattedMessage id={'homeVideo.video2'} /></p></li>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(3)}><FormattedMessage id={'homeVideo.video3'} /></p></li>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(4)}><FormattedMessage id={'homeVideo.video4'} /></p></li>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(5)}><FormattedMessage id={'homeVideo.video5'} /></p></li>
                      <li class="mb-3"><p onClick={()=> handleVideoToggle(6)}><FormattedMessage id={'homeVideo.video6'} /></p></li>
                    </ul>
                </div>
              </div>
              <div class="col-md-6 pb-4">
                <div id="video-container">
                  <img src={require('../../images/video-thumbnail.png')} onClick={()=> handleVideoToggle(1)}/>
                </div>
              </div>
            </div>
          </div>
        </section>
      <section id="documentacao">
        <hr className="mt-0"/>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <h3 className="mb-3 px-1"><FormattedMessage id={'documentationHelp.title'}/></h3>
            </div>
            <div className="col-md-8">
              <ul className="ps-4">
                <li className="mt-2 mb-2">
                  <a href={Faqs}
                     target="_blank"><FormattedMessage id={'documentationHelp.Faqs'}/></a>
                </li>
                <li className="mt-2 mb-2">
                  <a href="https://www.iefp.pt/documents/10181/11555740/Empreende_Aviso+de+abertura+de+Candidaturas_2023.pdf/329ec6c2-0f9d-4164-acfc-6e53fba92611"
                     target="_blank"><FormattedMessage id={'documentationHelp.CandidatureOpen'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://files.dre.pt/1s/2023/02/03000/0023900253.pdf" target="_blank"><FormattedMessage id={'documentationHelp.document2'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/file/d/1YQKDW44aFt6NaFmMdNlMWZ5gxNe5FIt_/view"
                     target="_blank"><FormattedMessage id={'documentationHelp.document3'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/file/d/1YHd6-pRBwBTRkz9iqX6WZToWGb8iN76x/view"
                     target="_blank"><FormattedMessage id={'documentationHelp.document4'}/></a> - <FormattedMessage id={'documentationHelp.document5'}/>
                </li>
                <li className="mb-2">
                  <a href={EAOrder}
                     target="_blank"><FormattedMessage id={'documentationHelp.document6'}/></a>
                </li>
                <li className="mb-2">
                  <a href={EADistrict}
                     target="_blank"><FormattedMessage id={'documentationHelp.document6.1'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/open?id=1ZUvxPSN9fVp7Q2fIS38YLHmr7PWLHwAj&authuser=patricia.roque%40startupportugal.com&usp=drive_fs"
                     target="_blank"><FormattedMessage id={'documentationHelp.document7'}/>
                  </a> <FormattedMessage id={'documentationHelp.document8'}/>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/open?id=1YmowpmcTqP-o-pHGFLsu4g64YwseaeyC&authuser=patricia.roque%40startupportugal.com&usp=drive_fs"
                     target="_blank"><FormattedMessage id={'documentationHelp.document9'}/></a> - <FormattedMessage id={'documentationHelp.document10'}/>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/open?id=1Yl1m3rYt7nTxcLEUIk9Fq6sXEaIZv5iv&authuser=patricia.roque%40startupportugal.com&usp=drive_fs"
                     target="_blank"><FormattedMessage id={'documentationHelp.document11'}/></a> - <FormattedMessage id={'documentationHelp.document12'}/>
                </li>
                <li className="mb-2">
                  <a href="https://docs.google.com/document/d/1jg-jy4AD8K9zaYs2yUubtzVge-yEWgSg/edit?usp=sharing&ouid=109860826081939699655&rtpof=true&sd=true"
                     target="_blank"><FormattedMessage id={'documentationHelp.document13'}/></a> - <FormattedMessage id={'documentationHelp.document14'}/>
                </li>
                <li className="mb-2">
                  <a href="https://docs.google.com/document/d/1qp7z5gc85Ek-508u1xMESClXT2oBkKvG/edit?usp=sharing&ouid=109860826081939699655&rtpof=true&sd=true"
                     target="_blank"><FormattedMessage id={'documentationHelp.document15'}/></a> - <FormattedMessage id={'documentationHelp.document16'}/>
                </li>
                <li className="mb-2">
                  <FormattedMessage id={'documentationHelp.document17'}/>
                  <a href={RegraMinimis}
                     target="_blank"><FormattedMessage id={'documentationHelp.document18'}/></a> <FormattedMessage id={'documentationHelp.document19'}/>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/open?id=1ZTueJdkCezu1aFEBKJ8dp-q88ZiFXl_d&authuser=patricia.roque%40startupportugal.com&usp=drive_fs"
                     target="_blank"><FormattedMessage id={'documentationHelp.document20'}/></a> <FormattedMessage id={'documentationHelp.document21'}/>
                </li>
                <li className="mb-2">
                  <a href={ConceitoProjetoInovador}
                     target="_blank"><FormattedMessage id={'documentationHelp.document22'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/file/d/1L2oyCrKkq2OYyIuPhFQ2W9vY4E6Ts3Dh/view"
                     target="_blank"><FormattedMessage id={'documentationHelp.document23'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/file/d/18CZYWQuG656yJkrbuf_ywFJh4Nx6NrsP/view"
                     target="_blank"><FormattedMessage id={'documentationHelp.document24'}/></a>
                </li>
                <li className="mb-2">
                  <a href="https://drive.google.com/file/d/1wCXG0Whb2VE12A6VGnyjMnTdJ4Kl0Vea/view"
                     target="_blank"><FormattedMessage id={'documentationHelp.document25'}/></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {ConfigObject.get().message &&
        <div className="homepage-message">{ConfigObject.get().message}</div>
      }

    </div>
  );
}

export default Home;
